<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูลกลุ่มสินค้า' : 'เพิ่มข้อมูลกลุ่มสินค้า' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <div class="row mb-3">
      <div class="col-sm-4"><label for="title" class="form-label mb-0 required">ชื่อกลุ่มสินค้า</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="title" formControlName="title"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="productGroupTypeId" class="form-label mb-0 required">ลักษณะกลุ่มสินค้า</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="productGroupTypeId" formControlName="productGroupTypeId" [compareWith]="compareByNumericValue">
          <option [ngValue]="null">กรุณาเลือก</option>
          @for (type of productGroupTypeOptions; track type.id) {
            <option [ngValue]="type.id">{{ type.title }}</option>
          }
        </select>
        @if (isProductGroupTypeLoading) {
          <div class="form-text">กำลังโหลดข้อมูลลักษณะกลุ่มสินค้า...</div>
        }
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="state" formControlName="state">
          <option [ngValue]="1">เผยแพร่</option>
          <option [ngValue]="0">ไม่เผยแพร่</option>
        </select>
      </div>
    </div>

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
